/**
 * 绩效评价埋点 SDK 封装
 * 文档参考: 绩效评价埋点操作文档-AI友好版.md
 *
 * 适配 Vue CLI 4.5 (process.env.VUE_APP_*) 而非 Vite
 */

const TRACKING_URL =
    process.env.VUE_APP_TRACKING_URL ||
    'https://rajxpj.wzgo.cn:6443/backend/eventTracking';

const TRACKING_APPID = process.env.VUE_APP_TRACKING_APPID || '';

let initialized = false;

/**
 * 初始化埋点 SDK
 * @param {string} newUserCode 后端 /login 返回的 AES 加密用户信息
 * @param {object} [router] Vue Router 实例,用于自动采集路由切换
 */
export async function initTracking(newUserCode, router) {
    if (!newUserCode) {
        console.warn('[tracking] newUserCode 为空,跳过埋点初始化');
        return;
    }
    if (initialized) return;

    try {
        // 动态加载,失败不影响登录主流程
        const { init } = await import('sfcom-acquisition');
        const acq = init({
            url: TRACKING_URL,
            app: TRACKING_APPID,
            user: newUserCode,
        });
        if (router) {
            acq.useVueRouter(router);
        }
        initialized = true;
        console.info('[tracking] 日志采集启动成功');
    } catch (e) {
        console.warn('[tracking] 日志采集初始化失败', e);
    }
}
